import * as React from 'react';
import TaskPane from './TaskPane';
import { collapsePaneUnderlay, expandPaneUnderlay } from '../utils/appPaneUnderlayUtils';
import { getClientApp } from 'owa-session-store';
import { getExtensibilityState, getTaskPaneRunningInstance, TaskPaneType } from 'owa-addins-store';
import { isPersistentTaskpaneEnabled } from 'owa-addins-feature-flags';
import { observer } from 'mobx-react';

export interface TaskPaneCollectionProps {
    renderTaskPaneInPanel?: boolean;
}

@observer
export default class TaskPaneCollection extends React.Component<TaskPaneCollectionProps, {}> {
    private previousTaskPanesSize: number;

    componentDidUpdate() {
        if (getClientApp() === 'Mail') {
            const { taskPanes } = getExtensibilityState();
            if (!this.previousTaskPanesSize && taskPanes.size) {
                expandPaneUnderlay();
            } else if (this.previousTaskPanesSize && !taskPanes.size) {
                collapsePaneUnderlay();
            }
            this.previousTaskPanesSize = taskPanes.size;
        }
    }

    private renderTaskPane(type: TaskPaneType) {
        const instance = getTaskPaneRunningInstance(type);
        return (
            instance && (
                <TaskPane
                    key={instance.controlId}
                    type={type}
                    instance={instance}
                    renderInPanel={this.props.renderTaskPaneInPanel}
                />
            )
        );
    }

    render() {
        const persistentTaskPane =
            isPersistentTaskpaneEnabled() && this.renderTaskPane(TaskPaneType.Persistent);
        const nonPersistentTaskPane = this.renderTaskPane(TaskPaneType.NonPersistent);

        return <React.Fragment>{[persistentTaskPane, nonPersistentTaskPane]}</React.Fragment>;
    }
}
